import { Link } from 'react-router-dom'
import logo from '../assets/mobile view logo.svg'
import dp from '../assets/Ellipse 68.svg'
import userStore from '../store/userStore'
import { observer } from "mobx-react";

const Header = observer(() => {
    return (
        <div className="fixed top-0 w-full bg-white flex justify-between items-center md:px-20 lg:px-20 md:p-[1%] lg:p-[1%] p-[5%] h-16 shadow-xl z-50">
            <img className='ml-2' src={logo} width={38} alt=''></img>
            { userStore.loggedIn ? 
                <div className='flex gap-4 items-center'>
                    <Link to='/faqs'><p className='text-semibold'>FAQ</p></Link>
                    <div className='rounded-full overflow-hidden'>
                        <img className='object-cover' src={dp} width={40} alt=''></img>
                    </div>
                </div>:
                <Link to='/register'><button className="border-primary border px-4 text-primary rounded-md md:h-12 h-8 max-md:text-xs">login</button></Link>
            }
        </div>
    );
});

export default Header;

